// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { PostState } from "@/types/post";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Post } from "@/models/post";

const state: PostState = {
  single: new Post(),
  pagination: new Pagination(),
};

export const post: Module<PostState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
